import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
//new Splide( '.splide' ).mount( { AutoScroll } );

// import { debounce as _debounce } from 'underscore';
// import { gsap } from 'gsap';
// import inView from 'in-view';

export default class {
	constructor(options) {
		// OPTIONS
		this.defaults = {

			$el: undefined,
			main: undefined,

			speedMultiply: 0,

			// internal swiper arrows
			arrows: false,

			// external swiper arrows
			$arrow_l: [],
			$arrow_r: [],

			speed: 0.25

		};

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.options.speedMultiply = parseFloat( this.options.speedMultiply );

		this.namespace = "splide_slideshow";

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;

		// init!!!!
		if (this.$el.length > 0) {
			//setTimeout( ()=>{
				this.init();
			//}, parseFloat( this.options.delay ) );
		}
	}

	init() {
		this.initSlider(true);
		// this.onResize();
	}

	initSlider(b) {
		if (b) {

			let autoStart = this.options.speedMultiply === 0,
				args;
			if ( !autoStart){
				this.options.speed *= this.options.speedMultiply;
			}

			//console.log( autoStart );

			args = {
				type: 'loop',
				gap: 20,
				pauseOnHover: false,
				
				//pauseOnFocus: false,
				arrows: false,
				pagination: false,
			  	autoScroll: {
			    	speed: this.options.speed,
			    	//autoStart: autoStart
			  	},	

			  	drag: $( 'html' ).hasClass( 'mobile' ) ? 'free' : true,
			  	waitForTransition: $( 'html' ).hasClass( 'mobile' ),

			  	perPage: 8,
			  	perMove: 8,
				breakpoints: {
					2300:{
						perPage: 7,
						perMove: 7
					},
					2000:{
						perPage: 6,
						perMove: 6
					},
					1780:{
						perPage: 5,
						perMove: 5
					},
					1420: {
						perPage: 4,
						perMove: 4
					},
					768: {
						perPage: 3,
						perMove: 3
					},
					480: {
						perPage: 2,
						perMove: 1,
						gap: 10
					} 
				}
			};

			if ( this.$el.hasClass( 'slideshow-splide-home-donors' ) ){
				args[ 'perPage' ] = 14;
				args[ 'perMove' ] = 14;
				args[ 'breakpoints' ] = {
					2600:{
						perPage: 12,
						perMove: 12
					},
					2300:{
						perPage: 10,
						perMove: 10
					},
					2000:{
						perPage: 8,
						perMove: 8
					},
					1780:{
						perPage: 6,
						perMove: 6
					},
					1420: {
						perPage: 4,
						perMove: 4
					},
					768: {
						perPage: 3,
						perMove: 3
					},
					480: {
						perPage: 2,
						perMove: 2,
						gap: 10
					} 
				}
			}

			//console.log( args );

			this.slider = new Splide( this.$el.find('.splide')[0], args );

			/*
			if ( ! autoStart ){

				console.log( this.options.delay );

				this.slider.on( 'mounted', ()=>{					
					setTimeout( ()=> {
						let Autoplay = this.slider.Components.Autoplay;
						Autoplay.play();

					}, this.options.delay );
				});
				

			}
			*/

			this.slider.mount( { AutoScroll } );

			//this.checkLoading();



		}
		else {

			this.slider.destroy();
		
		}

		//this.addEvents( b );
	}

	checkLoading(){

		if ( $( 'html' ).hasClass( 'mobile' ) ){
			this.$el[0].addEventListener('lazyloaded', function(e){
				//console.log( $(e.target) );
				$(e.target).attr( 'src', $(e.target)[0].currentSrc );
			    //console.log( $(e.target).attr( 'src' ) );
			});
		}

	}

	/*
    addEvents( b ){
		if ( b ){
		}
		else{
		}
		this.debounceResize(b);
    }
	*/

	/*
    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 117 );
			this.$win.on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$win.off( 'resize', this._debResize );
			}        
		}
    }
    */

	/*
    onResize(){
    }
	*/

	/*
    attachEventsKeyBoard( b ){
		if ( b ){
			if  ( !this.events_keyboard_attach ){
				this.events_keyboard_attach =   true;      
				this.$doc.on( 'keydown' , (e) => {
					if ( !inView.is( this.$el[0] ) ){
						return;
					}
					if( e.which === 39 || e.which === 40 ){
						// right arrow or dn
						this.nextSlide( true );
					}
					else if ( e.which === 37 || e.which === 38 ){
						// left arrow or up
						this.nextSlide( false );
					}
				});
			}
		}
		else{
			this.$doc.off( 'keydown' );
			this.events_keyboard_attach =   false;
		}
    }
    */

	destroy() {
		this.initSlider(false);
		this.$el.removeData();
	}
}
